import styles from './style.postcss';

import React from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { List, Record, Map } from 'immutable';
import {
  connect,
  moment,
  ApiCall,
  PrivilegeChecker,
  Config,
  ConfirmDialog,
  ErrorDialog,
  Grid,
  Checkbox,
  SolidRadio,
  ColourLabel,
} from 'omni-common-ui';
import PageActivitiesPart from './PageActivitiesPart';
import CoveredInClassCategoryView from './CoveredInClassCategoryView';
import { push } from 'react-router-redux';
import { actions as sessionPlansActions } from 'data/SessionPlans';
import { bindActionCreators } from 'redux';
import { actions as CoveredInClassActions, accessors, CoveredInClass as CoveredInClassModel } from 'data/CoveredInClass';
import { actions as CoveredInClassTemplateActions } from 'data/CoveredInClass/Template';
import { actions as CICCategoryTemplateActions } from 'data/CoveredInClass/CategoryTemplate';
import InternalNotesPart from './InternalNotesPart';
import { withRouter } from 'react-router';
import { exporter } from 'domain/Exporter';
import Privileges from 'domain/Privileges';
import Languages from 'domain/Languages';
import { actions as Group } from 'containers/Group';
import { actions as UiState } from 'data/UiState';
import { getUnitNumberById, getUnitList } from 'data/Units/accessors';
import UnsavedChangesTrackingPageComponent from 'components/UnsavedChangesTrackingPageComponent';
import UnsavedChangesWarning from 'components/UnsavedChangesWarning';
import NoContentMessage from 'components/NoContentMessage';
import LanguageRadio from 'components/LanguageRadio';
import AddFreeTextDialog from './AddFreeTextDialog';

import { Modes } from './routes';

const EXPORT = 'EXPORT';
const CANCEL = 'CANCEL';
const EXPORT_OPTION_ONE = 'one';
const EXPORT_OPTION_UNIT = 'unit';
const EXPORT_OPTION_ALL = 'all';
const TITLE_EXPORT_OPTIONS = 'Export Options';
const NAME_EXPORT_OPTIONS = 'export';
const DESCRIPTION_EXPORT_OPTIONS = 'Export Covered in Class for…';

export class CoveredInClass extends UnsavedChangesTrackingPageComponent {
  constructor(props) {
    super(props);

    this._onChecked = this._onChecked.bind(this);
  }

  componentWillMount() {
    this.state = {
      allowRouteLeave: false,
      isChanged: false,
      isExportInProgress: false,
      isExportErrorOccurred: false,
      isNotFoundSessions: false,
      isShowExportOptions: false,
      selectedExportValue: EXPORT_OPTION_ONE,
    };
    this._fetchData(this.props);
    super.componentWillMount();
    this._initChoosedLanguage();
    this._initCICContent();
    this._initCICCategory();
  }

  componentWillReceiveProps(props) {
    if (this.props.currentSessionIndex !== props.currentSessionIndex) {
      this.setState({
        allowRouteLeave: false,
        isChanged: false,
      });
    }
    this._fetchData(props);
    this._initCICContent();
  }

  _fetchData(props) {
    this.props.fetchSessionPlansIfNeeded(props.params.groupId);
    this.props.fetchCoveredInClassTemplateIfNeeded(props.params.sessionPlanId);
    this.props.fetchCoveredInClassIfNeeded(props.params.sessionPlanId);
  }

  _initCICCategory() {
    const { groupId } = this.props.params;
    this.props.fetchCICCategoriesIfNeeded(groupId);
  }

  _initCICContent() {
    const {
      coveredInClassTemplate,
      coveredInClassContent,
      hasCICTemplate,
      hasCIC,
      isNotPublished,
    } = this.props;
    if (! coveredInClassContent || ! hasCICTemplate || hasCIC || ! isNotPublished) {
      return;
    }
    if (this.props.isAnyApiCalling) {
      return;
    }
    let coveredInClassObject;
    if (this._canCICEdit()) {
      coveredInClassObject = coveredInClassContent;
      coveredInClassObject = coveredInClassObject.map((coveredInClass, key) =>
        coveredInClass.set('cicActivities', coveredInClassTemplate.get(key).cicActivities)
          .set('cicCategories', coveredInClassTemplate.get(key).cicCategories));
    } else if (! this._isNotFutureSession()) {
      coveredInClassObject = coveredInClassTemplate;
    } else {
      coveredInClassObject = coveredInClassContent;
      // coveredInClassObject = coveredInClassObject.map((coveredInClass, key) =>
      //     coveredInClass.update('cicActivities', coveredInClassTemplate.get(key).cicActivities)
      //       .set('cicCategories', coveredInClassTemplate.get(key).cicCategories));
    }
    this.props.changeCoveredInClassObject(coveredInClassObject, this.props.params.sessionPlanId);
  }

  _isChangesPresent() {
    // do not worry about notes - we will auto-save these on leaving
    return !! this.state.isChanged;
  }

  _isInCoveredInClassEditMode(pathname) {
    const { sessionPlanId } = this.props.params;
    return Object.values(Modes).some((mode) =>
      pathname.endsWith(`${sessionPlanId}/covered-in-class/${mode}`));
  }

  routerWillLeave(nextLocation) {
    if (nextLocation && nextLocation.pathname.endsWith(`/${Modes.EXPORT}`)) {
      this._onBeginExport();
      return false;
    } else if (nextLocation && nextLocation.pathname.endsWith(`/${Modes.PUBLISH}`)) {
      this._publishCIC();
      return false;
      // OMO-1254: user navigates away while editing a note; auto-save it
      // TODO: clean up fuzzy detection of whether we're staying on the same page
    } else if (nextLocation && nextLocation.pathname.endsWith(`/${Modes.CLEAR}`)) {
      this._clearCIC();
    } else if (this._willRemainOnCurrentPage(nextLocation)) return;

    this._autoSaveNotes();
    return super.routerWillLeave(nextLocation);
  }

  _autoSaveNotes() {
    if (! this.internalNotesPartComponent) return;
    this.internalNotesPartComponent.autoSaveNotesIfNeeded();
  }

  _willRemainOnCurrentPage(nextLocation) {
    const currentPath = this.props.buildRoute({ mode: '', index: '' });
    return nextLocation && (nextLocation.pathname.indexOf(currentPath) >= 0);
  }

  _pageActivitiesChanged(newPageActivities, unitId, lessonNumber) {
    this.setState({ isChanged: true });
    const { coveredInClassContent, params } = this.props;
    const newCoveredInClassContent = coveredInClassContent.update(`${unitId}-${lessonNumber}`,
      (cic) => cic.set('cicActivities', newPageActivities));
    this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
  }

  _categoriesChanged(newCategories, unitId, lessonNumber) {
    this.setState({ isChanged: true });
    const { coveredInClassContent, params } = this.props;

    const newCoveredInClassContent = coveredInClassContent.update(`${unitId}-${lessonNumber}`,
      (cic) => cic.set('cicCategories', newCategories));
    this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
  }

  _getModeAndIndex() {
    return { mode: this.props.params.mode, index: this.props.params.index };
  }

  _onChangeMode(modeAndIndex) {
    const { mode, index = '' } = modeAndIndex;
    this._forcePushRoute(this.props.buildRoute({ mode, index }));
  }

  _onBeginExport() {
    this.setState({
      isShowExportOptions: true,
      selectedExportValue: EXPORT_OPTION_ONE,
    });
    this._initChoosedLanguage();
  }

  _onEndExport() {
    this.setState({ isShowExportOptions: false });
  }

  _onBeginGeneralError() {
    this.setState({ isExportErrorOccurred: true });
  }

  _onBeginExportWarning() {
    this.setState({ isNotFoundSessions: true });
  }

  _onEndExportWarningOrError() {
    this.setState({
      isNotFoundSessions: false,
      isExportErrorOccurred: false,
    });
  }

  _renderExportOptionDialog() {
    return <ConfirmDialog isOpen={this.state.isShowExportOptions}
        isLoading={this.state.isExportInProgress}
        title={TITLE_EXPORT_OPTIONS}
        primaryButtonContent={EXPORT}
        secondaryButtonContent={CANCEL}
        onRequestClose={() => {
          this._onEndExport();
        }}
        onPrimaryClick={() => {
          this._handleConfirmExport();
        }}
        onSecondaryClick={() => {
          this._onEndExport();
        }}>
      <div>
        <div>{DESCRIPTION_EXPORT_OPTIONS}</div>
        <div className={styles.CoveredInClass_exportOptions}>
          <div className={styles.CoveredInClass_exportOption}>
            <SolidRadio id="1"
                value={EXPORT_OPTION_ONE}
                name={NAME_EXPORT_OPTIONS}
                isChecked={this.state.selectedExportValue === EXPORT_OPTION_ONE}
                onChange={(value) => this._handleExportChange(value)} />current session
          </div>
          <div className={styles.CoveredInClass_exportOption}>
            <SolidRadio id="2"
                value={EXPORT_OPTION_UNIT}
                name={NAME_EXPORT_OPTIONS}
                isChecked={this.state.selectedExportValue === EXPORT_OPTION_UNIT}
                onChange={(value) => this._handleExportChange(value)} />current unit
          </div>
          <div className={styles.CoveredInClass_exportOption}>
            <SolidRadio id="3"
                value={EXPORT_OPTION_ALL}
                name={NAME_EXPORT_OPTIONS}
                isChecked={this.state.selectedExportValue === EXPORT_OPTION_ALL}
                onChange={(value) => this._handleExportChange(value)} />all taught sessions
          </div>
        </div>
        {this._renderLanguagePicker()}
      </div>
    </ConfirmDialog>;
  }

  _renderLanguagePicker() {
    if (this._isDefaultLanguage()) return;
    return [
      <div className={styles.CoveredInClass_exportOptionsDivider}
          key="CoveredInClass_exportOptionsDivider" />,
      <div className={styles.CoveredInClass_languagePicker}
          key="CoveredInClass_languagePicker">
        <LanguageRadio title="Choose Language:"
            languageCode={this.props.languageCode}
            name="CICLanguagePicker"
            onChecked={this._onChecked}
            choosedLanguageCode={this.state.choosedLanguage} />
      </div>,
    ];
  }

  _initChoosedLanguage() {
    this.setState({ choosedLanguage: this.props.languageCode });
  }

  _isDefaultLanguage() {
    if (! this.props.languageCode) return true;
    return this.props.languageCode === Languages.defaultLanguageCode;
  }

  _onChecked(checkedLanguage) {
    this.setState({ choosedLanguage: checkedLanguage });
  }

  _handleExportChange(value) {
    this.setState({ selectedExportValue: value });
  }

  _handleConfirmExport() {
    const { sessionPlanId, groupId } = this.props.params;
    let sourceUrl = '';
    const languageQueryString =
      `?languageCode=${this.state.choosedLanguage || Languages.defaultLanguageCode}`;
    switch (this.state.selectedExportValue) {
      case EXPORT_OPTION_ONE:
        sourceUrl = `/sessions/${sessionPlanId}/cic-printing${languageQueryString}`;
        this._beginExport(Config.get('apiBase').concat(sourceUrl));
        break;
      case EXPORT_OPTION_UNIT:
        sourceUrl = `/sessions/${sessionPlanId}/unit-sessions/cic-printing${languageQueryString}`;
        this._beginExport(Config.get('apiBase').concat(sourceUrl));
        break;
      case EXPORT_OPTION_ALL:
        sourceUrl = `/groups/${groupId}/sessions/cic-printing${languageQueryString}`;
        this._beginExport(Config.get('apiBase').concat(sourceUrl));
        break;
      default:
        break;
    }
  }

  _handleExportError(error) {
    this.setState({
      isExportInProgress: false,
      isShowExportOptions: false,
    });
    if (error.response.status === 404) {
      this._onBeginExportWarning();
      return;
    }
    this._onBeginGeneralError();
  }

  _beginExport(url) {
    this.setState({
      isExportInProgress: true,
    });
    exporter.get(url,
      this.props.groupCode.concat('.pdf'),
      false,
      'application/pdf'
    ).then(() => {
      this.setState({
        isExportInProgress: false,
        isShowExportOptions: false,
      });
    }).catch((err) => {
      this._handleExportError(err);
    });
  }

  _renderExportNoSessionsFoundWarningDialog() {
    if (this.state.isNotFoundSessions) {
      return <ConfirmDialog isOpen
          content="No sessions are available for printing."
          primaryButtonContent="OK"
          onPrimaryClick={() =>
          this._onEndExportWarningOrError()} />;
    }
  }

  _renderExportGeneralErrorDialog() {
    if (this.state.isExportErrorOccurred) {
      return <ErrorDialog isOpen
          onConfirmClick={() => {
            this._onEndExportWarningOrError();
          }} />;
    }
  }

  _canCICEdit() {
    const { isNotPublished } = this.props;
    return isNotPublished &&
      this._isNotFutureSession();
  }

  _isNotFutureSession() {
    const { sessionPlans, currentSessionIndex } = this.props;
    const currentSession = sessionPlans.data.get(currentSessionIndex);
    const currentSessionDate = currentSession.period.start;
    return moment().isAfter(currentSessionDate);
  }

  _publishCIC() {
    this.setState({ isChanged: false });
    const {
      params: { sessionPlanId },
      publishCoveredInClass,
      fetchCoveredInClass,
    } = this.props;
    const { coveredInClassContent } = this.props;

    return coveredInClassContent && publishCoveredInClass(
      accessors.filterUncheckItems(coveredInClassContent).toArray(), sessionPlanId)
      .then(() => fetchCoveredInClass(sessionPlanId));
  }

  _clearCIC() {
    this.setState({ isChanged: false });
    const {
      params: { sessionPlanId },
      clearCoveredInClass,
      fetchCoveredInClass,
    } = this.props;

    this._onChangeMode({ mode: '', index: '' });
    return clearCoveredInClass(sessionPlanId)
      .then(() => fetchCoveredInClass(sessionPlanId));
  }

  _renderUnsavedChangesWarningDialog() {
    const { coveredInClassContent, isNotPublished } = this.props;

    if (this.props.isAnyApiCalling) {
      return null;
    }
    if (isNotPublished && accessors.isAllCategoryItemsUnchecked(coveredInClassContent)) {
      return <ConfirmDialog isOpen={!! this._isNavigationWithChangesRequested()}
          primaryButtonContent="Stay"
          secondaryButtonContent="Leave"
          content="Are you sure you want to leave this page and lose unsaved changes?"
          onPrimaryClick={() => {
            this._clearRequestedLocation();
          }}
          onSecondaryClick={() => {
            this.props.resetCoveredInClass(this.props.params.sessionPlanId);
            this._forcePushRequestedLocation();
          }}
          onRequestClose={() => {
            this._clearRequestedLocation();
          }} />;
    }
    return <UnsavedChangesWarning isOpen={
      !! this._isNavigationWithChangesRequested()}
        dialogText="Do you want to publish Covered in Class?"
        primaryButtonLabel="Publish to EF P"
        secondaryButtonContent="Discard"
        isSaving={this.props.isAnyApiCalling}
        onSaveClicked={() => {
          this._publishCIC()
          .then(() => {
            this._forcePushRequestedLocation();
          });
        }}
        onDiscardClicked={() => {
          this.props.resetCoveredInClass(this.props.params.sessionPlanId);
          this._forcePushRequestedLocation();
        }}
        onCloseClicked={() => {
          this._clearRequestedLocation();
        }} />;
  }

  _renderContent() {
    const {
      canEditCoveredInClass,
      changeCoveredInClassObject,
      coveredInClassContent,
      params: { sessionPlanId },
      hasCIC,
      hasCICTemplate,
      isNotPublished,
    } = this.props;

    if (coveredInClassContent && coveredInClassContent.loading) {
      return null;
    }
    // internal notes should be visible in all cases - even when there's no CIC content to show.
    const internalNotesPart = <InternalNotesPart onComponentMounted={(_cmpnt) => {
      this.internalNotesPartComponent = _cmpnt;
    }}
        modeAndIndex={this._getModeAndIndex()}
        onChangeMode={(modeAndIndex) => this._onChangeMode(modeAndIndex)}
        timeZone={this.props.timeZone}
        sessionPlanId={this.props.params.sessionPlanId} />;

    if (! hasCICTemplate && ! hasCIC) {
      return <Grid outerMargin>
        <Grid.Group>
          {internalNotesPart}
          <NoContentMessage text="No new course content was covered." />
        </Grid.Group>
      </Grid>;
    }
    const isEdit = this._canCICEdit() && canEditCoveredInClass;

    return <Grid outerMargin>
      <Grid.Group>
        {(isEdit || ! isNotPublished) &&
          <div className={styles.CoveredInClass_header}>
            {isEdit ?
              <label className={styles.CoveredInClass_header_checkAll}>
                <Checkbox name="check-all"
                    id="check-all"
                    checked={accessors.isAllCategoryItemsChecked(coveredInClassContent)}
                    onChange={() => {
                      this.setState({ isChanged: true });
                      const newCoveredInClassObject =
                      accessors.toggleCategoryItemsCheckedState(coveredInClassContent);
                      changeCoveredInClassObject(newCoveredInClassObject, sessionPlanId);
                    }} />
                <span>Check All</span>
              </label> : <lablel className={styles.CoveredInClass_header_checkAll} />}
              {! isNotPublished && <ColourLabel text="published" colour="green" />}
          </div>}
        {internalNotesPart}
        {this._renderLesson(coveredInClassContent, isEdit)}
      </Grid.Group>
      {this._renderExportOptionDialog()}
      {this._renderExportNoSessionsFoundWarningDialog()}
      {this._renderExportGeneralErrorDialog()}
    </Grid>;
  }

  _renderLesson(coveredInClassObject, isEdit) {
    const { coveredInClassTemplate } = this.props;
    const unchekedTemplate = accessors.toggleCategoryItemsCheckedState(coveredInClassTemplate);
    if (coveredInClassObject) {
      return coveredInClassObject.map((coveredInClass, key) => <div>
        {
          (coveredInClass.unitOrderingSequence && coveredInClass.lessonNumber) ?
            <h2>Unit {coveredInClass.unitOrderingSequence}, Lesson {coveredInClass.lessonNumber}</h2> : ''
        }
        <CoveredInClassCategoryView isEdit={isEdit}
            categories={coveredInClass.cicCategories}
            template={unchekedTemplate &&
              unchekedTemplate.get(key) &&
              unchekedTemplate.get(key).cicCategories}
            onCategoriesChanged={
            (newCategories) => this._categoriesChanged(
              newCategories,
              coveredInClass.unitId,
              coveredInClass.lessonNumber)
          } />
        <PageActivitiesPart pageActivities={coveredInClass.cicActivities}
            template={unchekedTemplate &&
                unchekedTemplate.get(key) &&
                unchekedTemplate.get(key).cicActivities}
            isEditMode={isEdit}
            onPageActivitiesChanged={
            (newPageActivities) => this._pageActivitiesChanged(
              newPageActivities,
              coveredInClass.unitId,
              coveredInClass.lessonNumber)
          } />
      </div>);
    }
    return null;
  }

  _closeFreeTextPopup() {
    this._onChangeMode({ mode: '', index: '' });
  }

  _addFreeText(CICKey, categoryId, freeText) {
    this.setState({ isChanged: true });
    const { cicCategoryTemplate, params } = this.props;
    let cicKey = CICKey;
    let { coveredInClassContent } = this.props;
    if (! coveredInClassContent) {
      const unitId = params.unitId || 0;
      cicKey = `${unitId}-0`;
      coveredInClassContent = new Map();
      coveredInClassContent = coveredInClassContent.set(`${unitId}-0`, CoveredInClassModel.create({
        cicCategories: [],
        cicActivities: [],
        unitId,
        lessonNumber: 0,
      }));
    }
    let cicCategories = coveredInClassContent.get(cicKey) &&
      coveredInClassContent.get(cicKey).get('cicCategories');

    if (! cicCategories || cicCategories.findIndex((x) => x.get('cicCategoryId') === categoryId) < 0) {
      if (! cicCategories) {
        cicCategories = new List();
      }
      const selectCategory = cicCategoryTemplate.find((x) => x.get('cicCategoryId') === categoryId);
      cicCategories = cicCategories.push(Record({
        cicCategoryId: undefined,
        cicCategoryItems: undefined,
        cicCategoryName: undefined,
      })({
        cicCategoryId: categoryId,
        cicCategoryItems: new List(),
        cicCategoryName: selectCategory.get('cicCategoryName'),
      }));
    }

    cicCategories = cicCategories && cicCategories.update(cicCategories.findIndex((x) => x.get('cicCategoryId') === categoryId),
      (category) => category.update('cicCategoryItems', (cicCategoryItems) => {
        const freeTextIndex = cicCategoryItems.findIndex((item) => item.cicCategoryItemId === 0);
        if (freeTextIndex >= 0) {
          return cicCategoryItems.update(freeTextIndex, (item) =>
            item.update('cicCategoryItemName', (cicCategoryItemName) => `${cicCategoryItemName}\n${freeText}`));
        }
        return cicCategoryItems.push(Record({
          cicCategoryItemId: undefined,
          cicCategoryItemName: undefined,
          isChecked: undefined,
        })({
          cicCategoryItemId: 0,
          cicCategoryItemName: freeText,
          isChecked: true,
        }));
      }
      ));

    let newCoveredInClassContent = new List();
    if (! coveredInClassContent) {
      newCoveredInClassContent = newCoveredInClassContent.push(Record({
        UnitId: undefined,
        cicCategories: undefined,
        cicActivities: undefined,
      })({
        cicCategories,
        cicActivities: new List(),
      }));
    } else {
      newCoveredInClassContent = coveredInClassContent && coveredInClassContent.update(cicKey,
      (cic) => cic.set('cicCategories', cicCategories));
    }

    this.props.changeCoveredInClassObject(newCoveredInClassContent, params.sessionPlanId);
    this._closeFreeTextPopup();
  }

  _renderFreeTextPopup() {
    const { cicCategoryTemplate, coveredInClassContent } = this.props;
    const shouldShowFreeTextPopup = this.props.params.mode &&
      this.props.params.mode === Modes.ADD_FREE_TEXT;
    return shouldShowFreeTextPopup &&
      <AddFreeTextDialog categoryOptions={cicCategoryTemplate}
          onCancel={() => this._closeFreeTextPopup()}
          coveredInClassContent={coveredInClassContent}
          onSave={(cicKey, categoryId, freeText) =>
          this._addFreeText(cicKey, categoryId, freeText)} />;
  }

  render() {
    const { sessionPlans } = this.props;

    if (! sessionPlans || ! sessionPlans.data) {
      return null;
    }

    return <div className={styles.CoveredInClass}>
      {this._renderUnsavedChangesWarningDialog()}
      {this._renderContent()}
      {this._renderFreeTextPopup()}
    </div>;
  }
}

CoveredInClass.getCurrentRouteSegment = (props) =>
  props.routes[props.routes.length - 1];

CoveredInClass.propTypes = {
  children: PropTypes.node,
  timeZone: PropTypes.string,
  groupName: PropTypes.string,
  groupCode: PropTypes.string,
  languageCode: PropTypes.string,
  sessionPlans: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  pushRoute: PropTypes.func.isRequired,
  currentSessionIndex: PropTypes.number,
  fetchSessionPlansIfNeeded: PropTypes.func,
  state: PropTypes.object.isRequired,
  router: PropTypes.any.isRequired,
  route: PropTypes.any.isRequired,
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  buildRoute: PropTypes.func.isRequired,
  fetchCoveredInClassIfNeeded: PropTypes.func.isRequired,
  fetchCoveredInClassTemplateIfNeeded: PropTypes.func.isRequired,
  coveredInClassObject: PropTypes.object,
  fetchCoveredInClass: PropTypes.func,
  changeCoveredInClassObject: PropTypes.func,
  publishCoveredInClass: PropTypes.func,
  clearCoveredInClass: PropTypes.func,
  canEditCoveredInClass: PropTypes.bool.isRequired,
  sessions: PropTypes.object,
  currentSessionId: PropTypes.string.isRequired,
  showNavigationBar: PropTypes.bool.isRequired,
  isAnyApiCalling: PropTypes.bool,
  isNotPublished: PropTypes.bool,
  hasCICTemplate: PropTypes.bool.isRequired,
  cicCategoryTemplate: PropTypes.object,
  fetchCICCategoriesIfNeeded: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  const { groupId, sessionPlanId } = ownProps.params;
  const group = state.get('rootReducer').get('groups').get(groupId).data;
  const { timeZone } = Group.getCentre(state, group.id);
  const languageCode = group.get('languageCode');
  const groupName = group.name;
  const groupCode = group.number;

  const { sessionPlans: sessionPlanIds } = group;
  if (is.undefined(sessionPlanIds.data)) {
    return { timeZone, groupName, sessionPlans: sessionPlanIds };
  }
  const isNotPublished = accessors.isNotPublished(state, ownProps.params);
  const hasCICTemplate = accessors.hasCICTemplate(state, ownProps.params);
  const hasCIC = accessors.hasCIC(state, ownProps.params);
  const sessionPlansInfo =
    state.get('rootReducer').get('sessionPlans').filter((session) => session.groupId === group.id);
  const units = getUnitList(state, groupId);
  const currentSessionPlanId = sessionPlanId;
  const sessionPlans = sessionPlanIds.update('data', (data) => new List(data))
    .update('data', (data) =>
      data.map((planId) => sessionPlansInfo.get(planId)));
  const currentSessionIndex = sessionPlans.data.findIndex((plan) =>
    plan.id === currentSessionPlanId
  );

  const cicCategoryTemplate = state
    .get('rootReducer')
    .get('cicCategoryTemplate')
    .get(groupId);

  const canEditCoveredInClass =
    ! Group.isAutoPublishCIC(state, groupId) &&
    ! Group.isHFV4CourseTypeGroup(state, groupId) &&
      PrivilegeChecker.hasPrivilege(state, Privileges.CoveredInClass.MarkAndPublish);

  let coveredInClassContent = state
    .get('rootReducer')
    .get('coveredInClassContent')
    .get(currentSessionPlanId);

  let coveredInClassTemplate = state
    .get('rootReducer')
    .get('coveredInClassTemplate')
    .get(currentSessionPlanId);
  coveredInClassTemplate = hasCICTemplate &&
    coveredInClassTemplate.map((CIC) =>
      CIC.set('unitOrderingSequence', getUnitNumberById(units, `${CIC.unitId}`)))
      .sort(sortCoverdInClass);

  if (hasCIC || ! isNotPublished) {
    coveredInClassContent = coveredInClassContent.map((CIC) =>
      CIC.set('unitOrderingSequence', getUnitNumberById(units, `${CIC.unitId}`)))
      .sort(sortCoverdInClass);
  } else {
    coveredInClassContent = coveredInClassTemplate;
  }

  const showNavigationBar = UiState.getShowNavigationBar(state);
  return {
    state,
    timeZone,
    groupName,
    groupCode,
    languageCode,
    sessionPlans,
    currentSessionIndex,
    coveredInClassContent,
    coveredInClassTemplate,
    canEditCoveredInClass,
    sessions: sessionPlansInfo,
    isNotPublished,
    hasCICTemplate,
    hasCIC,
    currentSessionId: currentSessionPlanId,
    showNavigationBar,
    isAnyApiCalling: !! isAnyApiCalling(state),
    cicCategoryTemplate,
  };
}

function sortCoverdInClass(a, b) {
  if (a.unitOrderingSequence !== b.unitOrderingSequence) {
    return a.unitOrderingSequence - b.unitOrderingSequence;
  }
  return a.lessonNumber - b.lessonNumber;
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(sessionPlansActions, dispatch),
    bindActionCreators(CoveredInClassActions, dispatch),
    bindActionCreators(CoveredInClassTemplateActions, dispatch),
    bindActionCreators(CICCategoryTemplateActions, dispatch),
  );
}

function isAnyApiCalling(state) {
  return !! (state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['PUT', 'POST', 'GET'].some((method) => key.startsWith(method)))
    .find((call) => ApiCall.State.isLoading(call));
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CoveredInClass));



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClass/component.jsx